import { render } from "./ProductsCanNotBePlaced.vue?vue&type=template&id=423c3b81"
import script from "./ProductsCanNotBePlaced.vue?vue&type=script&lang=js"
export * from "./ProductsCanNotBePlaced.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__